import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import BackgroundMusic from "../../components/BackgroundMusic";
import QuickSwapPopup from "../../components/QuickSwapPopup";
import RouletteHeader from "../../components/Roulette/Header/RouletteHeader";
import RouletteHistoryManageBoard from "../../components/Roulette/HistoryManageBoard/HistoryMangeBoard";
import RouletteMain from "../../components/Roulette/Main/RouletteMain";
import RouletteNumberBoard from "../../components/Roulette/NumberBoard/NumberBoard";
import NumberBoardHeader from "../../components/Roulette/NumberBoard/NumberBoardHeader";
import RouletteProfileBoard from "../../components/Roulette/ProfileBoard/RouletteProfileBoard";
import RouletteResultPopup from "../../components/RouletteResultPopup";

import bgMusic from "../../assets/sfxs/Roulettte/bgm.mp3";

import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  clearBets,
  getRoulettesAction,
  setBetResult,
  setCurrentRouletteId,
  updateBetDisabled,
  updateBetStatus,
  updateDefaultBetAmount,
} from "../../reducers/roulette.slice";

import { RouletteBetStatus } from "../../constants/enum/roulette";

import useGlobalSound from "../../hook/useGlobalSound";

import { getBusinessProfileAction } from "../../reducers/business.slice";
import useStyles from "./index.styles";

const Roulette = () => {
  const dispatch = useAppDispatch();
  const { classes } = useStyles();
  const { cityId } = useParams();

  const { currentRouletteId, roulettes, betResult, betStatus, betDisabled } =
    useAppSelector((state) => state.roulette);

  const [changedDefaultBetValue, setChangedDefaultValue] = useState(false);
  const [openQuickSwap, setOpenQuickSwap] = useState(false);

  const { muted } = useGlobalSound();

  useEffect(() => {
    dispatch(getRoulettesAction());
  }, [dispatch]);

  useEffect(() => {
    const rouletteId = Number(cityId);

    dispatch(setCurrentRouletteId(rouletteId));
  }, [dispatch, cityId]);

  useEffect(() => {
    if (!roulettes[currentRouletteId] || changedDefaultBetValue) return;

    setChangedDefaultValue(true);
    dispatch(updateDefaultBetAmount(roulettes[currentRouletteId].minBet));
  }, [currentRouletteId, dispatch, roulettes, changedDefaultBetValue]);

  useEffect(() => {
    dispatch(getBusinessProfileAction({ itemId: 48, cityId: Number(cityId) }));
  }, [dispatch, cityId]);

  return (
    <Box className={classes.body}>
      <BackgroundMusic muted={muted} backgroundMusic={bgMusic} volume={0.2} />

      <RouletteHeader handleOpenQuickSwap={() => setOpenQuickSwap(true)} />

      <Box className={classes.rouletteBody}>
        <Box className={classes.rouletteBodyBox}>
          <Box className={classes.rouletteBodyBoxInner}>
            <RouletteMain />
          </Box>

          <Box className={classes.rouletteBodyBox2}>
            <NumberBoardHeader />

            <RouletteNumberBoard
              betDisabled={betDisabled}
              betStatus={betStatus}
            />
          </Box>
        </Box>

        <Box className={classes.rouletteBodyBox} sx={{ gap: 2 }}>
          <RouletteProfileBoard />

          <RouletteHistoryManageBoard />
        </Box>
      </Box>

      <RouletteResultPopup
        openPopup={betStatus === RouletteBetStatus.FINISHED && !!betResult}
        handleClose={() => {
          dispatch(updateBetStatus(RouletteBetStatus.NOT_REQUESTED));
          dispatch(updateBetDisabled(false));
          dispatch(clearBets());
          dispatch(setBetResult(null));
        }}
      />

      <QuickSwapPopup
        openPopup={openQuickSwap}
        handleClose={() => {
          setOpenQuickSwap(false);
        }}
      />
    </Box>
  );
};

export default Roulette;
